import { Column } from 'react-table';

import { DataSourcesTableItem, useDataSourcesTableColumns } from '@neo.tax/shared';

/**
 * On R&D, tax documents, ticketing files, payroll costs and business component lists are uploads the
 * customer deletes; everything else in these tables is a connection they disconnect.
 */
const RD_DELETABLE_ITEM_TYPES: ReadonlySet<DataSourcesTableItem['itemType']> = new Set([
  'tax-document',
  'ticketing-file',
  'rd-payroll-cost',
  'rd-business-components-file',
]);

export const useRdDataSourcesTableColumns = (
  options: Omit<Parameters<typeof useDataSourcesTableColumns>[0], 'deletableItemTypes'>,
): Column<DataSourcesTableItem>[] =>
  useDataSourcesTableColumns({ ...options, deletableItemTypes: RD_DELETABLE_ITEM_TYPES });
